import React, { useEffect, useState } from "react";
import { Link, Route, Routes, useLocation } from "react-router-dom";
import { ReactComponent as Logo } from "./../../graphics/logo.svg";
// import MenuIcon from "./../../graphics/MenuIcon.png";
import { Badge, Layout, Menu, MenuProps } from "antd";
import { useSelector } from "react-redux";
import { AppRoutes } from "../../data";
import DashboardPage from "../../pages/DashboardPage";
import { setIsShowTableInDesktop } from "../../redux-toolkit/slices/generalSlice";
import { RootState, useAppDispatch } from "../../redux-toolkit/store/store";
import "./layout.css";
import TopNav from "./TopNav";
const { Content } = Layout;
type MenuItem = Required<MenuProps>["items"][number];

const AppLayout = () => {
  const dispatch = useAppDispatch();
  const generalState = useSelector((state: RootState) => state.general);
  const { meta } = useSelector((state: RootState) => state.chat);

  const [routes, setRoutes] = useState<IRoute[]>([]);
  const [items, setItems] = useState<MenuItem[]>([]);
  const updateScreenSize = () => {
    const isDesktop = window.innerWidth > 1000;
    dispatch(setIsShowTableInDesktop(isDesktop));
  };
  useEffect(() => {
    // Initial check
    updateScreenSize();

    // Add event listener for resize
    window.addEventListener("resize", updateScreenSize);

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener("resize", updateScreenSize);
    };
  }, [dispatch]);

  useEffect(() => {
    setRoutes(AppRoutes());
  }, []);
  const location = useLocation();
  // const navigate = useNavigate();
  useEffect(() => {
    const routes = AppRoutes();
    let unreadCount = 0;
    for (const item of meta) {
      unreadCount = unreadCount + item.unreadCountForAdmin;
    }
    const _items = routes
      .filter((item: any) => item.show === true)
      .map((item: any) => {
        return {
          key: item.path,
          // icon: (
          //   <img
          //     src={
          //       location.pathname === item.path ? item.activeIcon : item.icon
          //     }
          //   />
          // ),
          label:
            item.path === "/chat" ? (
              <Link to={item.path}>
                {item.text}
                <Badge count={unreadCount} size="small" offset={[5, -15]} />
              </Link>
            ) : (
              <Link to={item.path}>{item.text}</Link>
            ),
        };
      });
    setItems(_items);
  }, [location, meta]);

  const styles = {
    menuBar: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "10px 20px",
      backgroundColor: "white",
      borderBottom: "1px solid #e5e7eb",
      marginBottom: "40px",
      height: "100px",
    } as React.CSSProperties,
    contentWrapper: {
      padding: "24px 20px 24px 20px",
    } as React.CSSProperties,
    menuLeft: {
      display: "flex",
      alignItems: "center",
    } as React.CSSProperties,
    logo: {
      height: "50px",
      width: "auto",
    } as React.CSSProperties,
    navigationMenuBar: {
      display: "flex",
      alignItems: "center",
      backgroundColor: "#F1F4F6",
      borderRadius: "50px",
      padding: "10px 20px",
      width: "fit-content",
    } as React.CSSProperties,
    menuItem: {
      fontFamily: "'Montserrat', sans-serif",
      fontSize: "18px",
      fontWeight: 600,
      color: "#495666",
      padding: "5px 15px",
      cursor: "pointer",
      transition: "color 0.3s ease",
    } as React.CSSProperties,
    activeMenuItem: {
      color: "#1D354F",
    } as React.CSSProperties,
    menuIcon: {
      marginRight: "8px",
    } as React.CSSProperties,

    dropdownItemHover: {
      backgroundColor: "#f5f5f5",
    } as React.CSSProperties,
  };

  return (
    <>
      <Layout>
        <div className="app-main-menu-bar">
          <div style={styles.menuLeft}>
            <Logo style={styles.logo} />
          </div>
          <Menu
            className="my-app-menu"
            mode="horizontal"
            selectedKeys={[location.pathname]} // Highlight the active menu item
            items={items}
            style={{ backgroundColor: "#F1F4F6" }}
          />
          <TopNav menuItems={items} />
        </div>
        <Content className="main-content-wrapper">
          <Routes>
            <Route path="/" element={<DashboardPage />} />
            {/* isLoggedIn  */}
            {routes.map((route: any) => {
              return (
                <Route
                  path={route.path}
                  key={Math.random()}
                  element={<route.Component />}
                />
              );
            })}
          </Routes>
        </Content>
      </Layout>
    </>
  );
};

export default AppLayout;
